import { useInspection } from "providers/InspectionProvider";
import { useState } from "react";
import FunctionalButton from "components/layout/FunctionalButton";

const InspectionPopup = () => {
    const {
        captureData,
        inspectionData,
        showInspectionPopup,
        closeInspectionPopup,
        inspectCaptured,
        resetCapture,
        askAnotherQuestion
    } = useInspection();

    // Form state
    const [inspectionType, setInspectionType] = useState("questCap");
    const [questionInput, setQuestionInput] = useState("");

    if (!showInspectionPopup) return null;

    // Determine current step
    const isCapturing = captureData.status === 'capturing';
    const isCaptured = captureData.status === 'ready';
    const isInspecting = inspectionData.status === 'inspecting';
    const isComplete = inspectionData.status === 'complete';
    const hasError = captureData.status === 'error' || inspectionData.status === 'error';

    // Determine which image to display
    const displayImageUrl = inspectionData.annotatedImageUrl || captureData.imageUrl;

    // Handle submit question
    const handleSubmit = (e) => {
        e.preventDefault();
        inspectCaptured(questionInput, inspectionType);
    };

    return (
        <div className="fixed inset-0 z-[99] bg-black bg-opacity-80 flex items-center justify-center p-4">
            <div className="bg-base-100 rounded-lg w-full h-full max-w-[95vw] max-h-[95vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="p-4 border-b border-base-300 flex justify-between items-center">
                    <h2 className="text-xl font-bold">
                        Inspection
                    </h2>
                    <button onClick={closeInspectionPopup} className="btn btn-sm btn-circle btn-ghost">
                        ✕
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-hidden">
                    {/* Mobile layout: Vertical stack */}
                    <div className="flex h-full w-full">
                        {/* Image section */}
                        <div className="flex-1 bg-base-200 flex flex-col items-center justify-center p-4 flex-grow-1">
                            {(isCapturing || isInspecting) && (
                                <div className="flex flex-col items-center gap-4">
                                    <span className="loading loading-spinner loading-lg"></span>
                                    <div className="text-center">
                                        {/* {isInspecting && "Analyzing with AI..."} */}
                                        {isCapturing && "Capturing image..."}
                                    </div>
                                </div>
                            )}
                            {displayImageUrl && (isCaptured || isComplete) && (
                                <img
                                    src={displayImageUrl}
                                    alt="Captured"
                                    className="max-w-full max-h-[500px] h-full object-contain"
                                />
                            )}
                            {hasError && (
                                <div className="text-error text-center">
                                    <p className="text-xl">Operation failed</p>
                                    <p className="text-sm mt-2">Please close and try again</p>
                                </div>
                            )}
                            {isCaptured && <div>
                                <p className="text-xs text-base-content/60">
                                    {captureData.width} × {captureData.height}
                                </p>
                            </div>}
                        </div>

                        {/* Bottom panel */}
                        <div className="min-h-[250px] max-h-[100%] flex-shrink-0 bg-base-100 p-4 overflow-y-auto border-t border-base-300 max-w-[25%]">
                            {/* Step 2: Question form (mobile) */}
                            {isCaptured && (
                                <div className="space-y-3">
                                    <form onSubmit={handleSubmit} className="space-y-3">
                                        <div className="flex gap-2">
                                            <FunctionalButton
                                                className={`h-9 w-fit rounded-r5 px-4 flex-1 ${inspectionType === "questCap"
                                                    ? "bg-gray-500  text-white"
                                                    : "bg-gray-700 text-gray bg-opacity-50"}`}
                                                title="Q&A"
                                                titleClassName="text-h3"
                                                onClick={() => setInspectionType("questCap")}
                                            />
                                            <FunctionalButton
                                                className={`h-9 w-fit rounded-r5 px-4 flex-1 ${inspectionType === "detection"
                                                    ? "bg-gray-500  text-white"
                                                    : "bg-gray-700 text-gray bg-opacity-50"}`}
                                                title="Detect"
                                                titleClassName="text-h3"
                                                onClick={() => setInspectionType("detection")}
                                            />
                                        </div>

                                        <textarea
                                            className="w-full bg-black80 text-white px-3 py-2 rounded-r5 h-20"
                                            placeholder={
                                                inspectionType === "detection"
                                                    ? "Object to detect..."
                                                    : "Question (optional)..."
                                            }
                                            value={questionInput}
                                            onChange={(e) => setQuestionInput(e.target.value)}
                                        />

                                        <FunctionalButton
                                            className="h-9 w-full rounded-r5 bg-primary2 px-4"
                                            disabled={isInspecting}
                                            title={isInspecting ? "Analyzing with AI..." : "Ask"}
                                            titleClassName="text-h3"
                                            onClick={handleSubmit}
                                        />
                                        <FunctionalButton onClick={resetCapture} className="h-9 w-full rounded-r5 bg-gray-900 px-4" title="New Capture" titleClassName="text-h3">
                                        </FunctionalButton>
                                        {/* Step 4: Results (mobile) */}
                                        {isComplete && (
                                            <div className="space-y-3">
                                                <div>
                                                    <h3 className="font-bold mb-2">Result</h3>
                                                    <p className="">{inspectionData.resultMessage}</p>
                                                </div>

                                                <div className="flex gap-2">
                                                    {/* <button
                                                        onClick={askAnotherQuestion}
                                                        className="btn btn-xs btn-outline flex-1"
                                                    >
                                                        Ask Again
                                                    </button> */}
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>

                            )}



                            {/* Error (mobile) */}
                            {hasError && (
                                <div className="text-error space-y-2">
                                    <p className="text-sm">An error occurred</p>
                                    <button onClick={closeInspectionPopup} className="btn btn-error btn-sm w-full">
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InspectionPopup;
